module.exports = __webpack_public_path__ + "static/media/CHF.de427fe2.svg";